import { Injectable } from '@angular/core';

import { MarketSubTypeLogoService } from '../../../../lib/marketsubtype-logo/marketsubtype-logo.service';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../../core/picks/betslip-v1-pick';
import { getOptionIsDraw } from '../../../core/utils';

@Injectable()
export class BetslipMarketSubTypeLogoService {
    constructor(private marketSubTypeLogoService: MarketSubTypeLogoService) {}

    getMarketSubTypeLogoTitle(pick: BetslipPick | undefined): string | undefined {
        return pick && (getOptionIsDraw(pick) === false || pick instanceof BetslipV1Pick)
            ? this.marketSubTypeLogoService.getMarketSubTypeLogoTitle(
                  pick.id.fixtureId,
                  pick.sportId,
                  pick.market.marketType,
                  pick.market.marketSubType,
                  pick.market.templateId?.toString(),
              )
            : undefined;
    }

    getMarketSubTypeSignpostingText(pick: BetslipPick | undefined): string | undefined {
        return pick && getOptionIsDraw(pick) === false
            ? this.marketSubTypeLogoService.getMarketSubTypeSignpostingText(pick.sportId, pick.market.marketType, pick.market.marketSubType)
            : undefined;
    }
}
